import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EventCard from './components/EventCard'
import PageTitle from '../../../components/PageTitle'
import Loader from '../../../components/Loader'
import Empty from '../../../components/Empty'
import { getEvents } from '../../../actions/participant'
import { formatRange } from '../../../utils/smallHelpers'


const Events = () => {
  const dispatch = useDispatch()
  const events = useSelector((state) => state.participant.events.list)
  const loading = useSelector((state) => state.participant.loading)

  useEffect(() => {
    dispatch(getEvents())
  }, [dispatch])

  const items = useMemo(() => (events || []).map((e) => ({
    id: e.id,
    title: e.name,
    location: e.location || '',
    dates: formatRange(e.start_date, e.end_date),
    description: e.description || '',
  })), [events])

  return (
    <section>
      <PageTitle title="Доступные мероприятия" />
      {loading ? (
        <Loader size="lg" color="rgb(218 35 41)" />
      ) : items.length === 0 ? (
        <Empty />
      ) : (
        <div className="flex flex-col items-stretch gap-[1.25rem]">
          {items.map((item) => (
            <EventCard key={item.id} {...item} />
          ))}
        </div>
      )}
    </section>
  )
}

export default Events
